import { ExtensionOption } from '../../extension-register/models/extension-option.interface';

export interface PagingGroupMemberItemView extends ExtensionOption {
   pagingGroupMemberId: number;
   extensionPagingGroupId: number;
}

export const pagingGroupMemberKeyFields: string[] = ['pagingGroupMemberId', 'extensionPagingGroupId', 'extensionId'];
